import { z } from 'zod'

import { DateZod } from '../../common'

const BaseTeamEventZod = z.object({
  timestamp: DateZod,
})

export const TeamEventZod = z.discriminatedUnion('type', [
  BaseTeamEventZod.extend({
    type: z.literal('setVehicleMileageStart'),
    vehicleMileageStart: z.number(),
    odometerPhotoUrl: z.string().url().nullish(),
  }),

  BaseTeamEventZod.extend({
    type: z.literal('beginParticipation'),
    vehicleMileageStart: z.number(),
  }),

  BaseTeamEventZod.extend({
    type: z.literal('endParticipation'),
    vehicleMileageEnd: z.number().nullable(),
    odometerPhotoUrl: z.string().url().nullish(),
  }),

  BaseTeamEventZod.extend({
    type: z.literal('onBreak'),
  }),

  BaseTeamEventZod.extend({
    type: z.literal('resume'),
  }),

  BaseTeamEventZod.extend({
    type: z.literal('inReturn'),
  }),
])

export type TeamEvent = z.infer<typeof TeamEventZod>
